<template>
    <div :class="['p-4 rounded-lg shadow-md ', titleColor, bgColor]">
        <div class="flex flex-col md:flex-row md:items-end justify-between">
            <h2 class="text-3xl font-bold mb-4">{{ name }}</h2>
            <div
                class="flex flex-col md:flex-row md:items-center gap-2 md:gap-4"
            >
                <p class="text-white text-xl font-extrabold md:mb-0">
                    NOK {{ price }}<br />30 min
                </p>
                <NuxtLink :to="$localeRoute('/patients/virtual-clinic')">
                    <button
                        class="border-2 border-white text-white px-4 py-2 rounded-lg hover:bg-white hover:text-black transition"
                    >
                        {{ $t("patients.virtualClinic.enroll") }}
                    </button>
                </NuxtLink>
            </div>
        </div>
        <ul class="space-y-2">
            <li
                v-for="(item, index) in items"
                :key="index"
                class="flex items-center rounded-md p-2 bg-transparent text-white"
            >
                <svg
                    class="w-6 h-6 text-white mr-4"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                >
                    <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M9 12l2 2l4 -4"
                    />
                </svg>
                <p class="text-2xl">{{ $t(item) }}</p>
            </li>
        </ul>
    </div>
</template>

<script setup lang="ts">
const props = defineProps<{
    name: string;
    items: string[];
    bgColor: string;
    titleColor: string;
    textColor: string;
    price: number;
    link: string;
}>();
</script>

<style scoped>
/* Additional custom styles if needed */
</style>
